
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mock-test",
      function () {
        return require("private-next-pages/mock-test.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mock-test"])
      });
    }
  